<template>
  <GmbControlColumn>
    <GmbSection :displayLevel="1" height="parent" lockHeader title="Sélection">
      <template #picto>
        <FdText colorTheme4 fa><i class="fas fa-users"/></FdText>
      </template>

      <template #infoSticker>
        <GmbSticker :text="individuals ? individuals.length : 0"/>
      </template>

      <template v-if="individuals.length > 0">
        <div
            v-for="(individual, i) in individuals"
            :class="['d-flex flex-column', { 'mt-1 border-top pt-1': i != 0 }]"
            :key="i"
        >
          <GmbRow>
            <FdText tag="span">{{
                individual.reference_id || "#" + individual.pk
              }}
            </FdText>

            <!-- FIXME deduplicate these address displays into individual utilities!! -->
            <FdText v-if="individual.individual_email" tag="span">{{ individual.individual_email }}</FdText>
            <FdText
                v-if="
                individual.address || individual.postcode || individual.city
              "
                tag="span"
            >{{
                individual.address +
                "\n" +
                individual.postcode +
                " " +
                individual.city
              }}
            </FdText
            >
          </GmbRow>
        </div>
      </template>

      <GmbRow v-else>
        <FdText tag="span">Aucune donnée</FdText>
      </GmbRow>
    </GmbSection>

    <template #controls>
      <b-button
          v-if="individuals && individuals.length"
          class="d-flex p-1 justify-content-center align-items-center text-size-reset rounded-1"
          variant="primary"
          @click="onDownloadButtonClick"
      >
        <FdText fa><i class="fas fa-download"/></FdText>
        <FdText class="mx-2" tag="span"
        >Télécharger&nbsp;les&nbsp;données
        </FdText
        >
      </b-button>
      <form :action="backofficeIndividualsEditionUrl" target="_blank" method="POST">
        <b-button
            v-if="individuals && individuals.length && userAccount.is_superuser"
            class="d-flex ml-2 p-1 justify-content-center align-items-center text-size-reset rounded-1"
            variant="primary"
            type="submit"
        >
          <FdText fa><i class="fa fa-pencil-square-o"/></FdText>
          <FdText class="mx-2" tag="span">
            Back-Office
          </FdText>
          <input type="hidden" name="ids" :value="selectedIndividualPksString">
        </b-button>
      </form>
    </template>
  </GmbControlColumn>
</template>

<script>
import {BACKEND_API_URL, rawGetUrl, rawPostUrl, triggerDownloadOfBinaryData} from "@/services/base";

import FdText from "@/flexdesign/Text";

import GmbControlColumn from "@/widgets/ControlColumn";
import GmbRow from "@/widgets/Row";
import GmbSection from "@/widgets/Section";
import GmbSticker from "@/widgets/Sticker";

export default {
  name: "GmbDataEditionSelectedIndividuals",

  components: {
    FdText,
    GmbControlColumn,
    GmbRow,
    GmbSection,
    GmbSticker,
  },

  props: {
    currentClientPk: Number,
    currentProjectPk: Number,
    individuals: Array,
    userAccount: Object,
  },

  data() {
    return {};
  },

  computed: {

    selectedIndividualPksString: function () {  // OBSOLETE FIXME
      let selectedIndividualPks = this.individuals.map(
          (individual) => individual.pk
      );
      let selectedIndividualPksString = selectedIndividualPks.join(",");
      return selectedIndividualPksString;
    },

    selectedIndividualPksArray: function () {
      let selectedIndividualPks = this.individuals.map(
          (individual) => individual.pk
      );
      return selectedIndividualPks;
    },

    backofficeIndividualsEditionUrl: function () {
      let backofficeUrlSuffix = `backoffice/clients/${this.currentClientPk}/projects/${this.currentProjectPk}/individuals/register-list/`;
      let backofficeUrl = new URL(backofficeUrlSuffix, BACKEND_API_URL).href;
      return backofficeUrl;
    },
  },

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {
    onDownloadButtonClick() {
      let selectedIndividualPksArray = this.selectedIndividualPksArray;
      let urlSuffix = `api/projects/${this.currentProjectPk}/export-csv/`;
      let downloadUrl = new URL(urlSuffix, BACKEND_API_URL).href;

      rawPostUrl(downloadUrl, {individuals: selectedIndividualPksArray}).then((response) => {
        triggerDownloadOfBinaryData(response.data, "individuals_export.csv")
      });
    },
  },
};
</script>

<style lang="scss"></style>
